var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownCorpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.828122 1.92424L6.28828 8.29612C6.37629 8.39877 6.48547 8.48117 6.60831 8.53766C6.73116 8.59415 6.86478 8.6234 7 8.6234C7.13521 8.6234 7.26883 8.59415 7.39168 8.53766C7.51453 8.48117 7.6237 8.39877 7.71172 8.29612L13.1719 1.92424C13.693 1.31604 13.2609 0.376587 12.4602 0.376587H1.53828C0.737497 0.376587 0.305466 1.31604 0.828122 1.92424Z",
    fill: "#FEF5EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCorpIcon);
export default __webpack_public_path__ + "static/media/downCorpIcon.ae9712d61c0d563ae6016b030ed94fc8.svg";
export { ForwardRef as ReactComponent };